import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { useState } from 'react'

import { SubmitFeedbackModal } from './SubmitFeedbackModal'

export const SubmitFeedbackModalButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const translate = useTranslate()

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)} startIcon="Envelope">
        {translate('feedbackModalButton.button')}
      </Button>
      <SubmitFeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  )
}
